import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Output
} from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validators } from '@angular/forms';
import { CompleterData, CompleterService } from 'ng2-completer';
import { CONFIG } from '../../../config';
import { CatalogueService } from '../../../core/service/core/cataloque.service';
import { ValidatorService } from '../../../core/service/app/validator.service';
import { CommerceService } from 'app/core/service/app/commerce.service';

@Component({
  selector: 'app-address-commerce-form',
  templateUrl: './address-commerce-form.component.html',
  styleUrls: ['./address-commerce-form.component.scss']
})
export class AddressCommerceFormComponent extends FormBaseComponent<any>
  implements OnInit, OnChanges {
  @Input()
  postalCode: string;

  @Output()
  onUpdateTelefono = new EventEmitter();

  commerceName = '';

  protected searchStr: string;
  protected dataService: any;

  listColony = [];

  codigoPostal = '0';

  constructor(
    private commerce: CommerceService,
    private completerService: CompleterService,
    private catalogueService: CatalogueService,
    public validatorService: ValidatorService
    
  ) {
    super();
    this.dataService = completerService.remote(
      CONFIG.url + 'catalogue/postalcode/',
      null,
      null
    );


  }

  ngOnInit() {
    this.init(true);
    if (this.postalCode) {
      this.loadData(this.postalCode);
    }
    this.form.valueChanges.subscribe(state => {
      if (this.codigoPostal != state.postalCode) {
        this.codigoPostal = state.postalCode;
        this.loadData(this.codigoPostal);
      }
    });
  }


  template() {
    this.form.addControl('postalCode', new FormControl('', []));
    this.form.addControl('estate', new FormControl('', Validators.required ));
    this.form.addControl('municipality', new FormControl('', Validators.required ));
    this.form.addControl('colony', new FormControl(0, Validators.required));
    this.form.addControl('street', new FormControl('', Validators.required));
    this.form.addControl(
      'phone1',
      new FormControl('', [this.validatorService.telefono])
    );
    this.form.addControl(
      'phone2',
      new FormControl('', [this.validatorService.telefono])
    );
    this.form.addControl('numInt', new FormControl(''));
    this.form.addControl('numExt', new FormControl(''));
    this.form.addControl('population', new FormControl());
    this.form.addControl('noComercios', new FormControl());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.postalCode) {
        if (changes.postalCode.currentValue != this.codigoPostal) {
          this.loadData(changes.postalCode.currentValue);
          this.codigoPostal = changes.postalCode.currentValue;
        }
        if (this.form) {
          this.form.patchValue({ postalCode: changes.postalCode.currentValue });
        }
      }
    }
  }
  updateTelefono() {
    this.onUpdateTelefono.emit(this.form.value.phone1);
  }

  loadData(value: string) {
    if(value != undefined)
    {
      if (value != '00000' && value.length > 0 && value != "0") {
        this.listColony = [];
        this.catalogueService.getByPostalCode(value).then(result => {
          if (result != undefined) {
            this.form.patchValue({
              estate: result.state,
              municipality: result.municipality
            });
            result.colonies.map(item => {
              let colony = { text: item.text, value: item.value };
              if (this.listColony.indexOf(colony) === -1) {
                this.listColony.push(colony);
              }
            });
          }
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/address-commerce-form/address-commerce-form.component.ts